//repair center name link fn 20201020 LGERU-98 add 
function goProviderDetail(ascUrl, ascLatitudeValue, ascLongitudeValue, ascPostalCode, postalCode, dmsFlag){
	var f						= document.repairForm;
	f.action					= ascUrl; // Json
	f.dmsFlag.value	            = dmsFlag; // Json
	f.target                    = "_blank";
	f.method 					= document.repairForm.getAttribute("method");
	f.submit(); 
}
// autocomplete function
!function (e) {
    "use strict";
    function t(n, o) {
        var s = function () { },
            i = this,
            a = {
                autoSelectFirst: !1,
                // appendTo: document.body,
                appendTo: $("#storeSearchForm .input-wrapper"),
                serviceUrl: null,
                lookup: null,
                onSelect: null,
                width: "auto",
                minChars: 1,
                maxHeight: 300,
                deferRequestBy: 0,
                params: {},
                formatResult: t.formatResult,
                delimiter: null,
                zIndex: 9999,
                type: "GET",
                noCache: !1,
                onSearchStart: s,
                onSearchComplete: s,
                onSearchError: s,
                containerClass: "suggestion-list",
                tabDisabled: !1,
                dataType: "text",
                currentRequest: null,
                triggerSelectOnValidInput: !0,
                preventBadQueries: !0,
                lookupFilter: function (e, t, n) {
                    return -1 !== e.value.toLowerCase().indexOf(n)
                },
                paramName: "query",
                transformResult: function (t) {
                    return "string" == typeof t ? e.parseJSON(t) : t
                },
                showNoSuggestionNotice: !1,
                noSuggestionNotice: "No results",
                orientation: "bottom",
                forceFixPosition: !1
            };
        i.element = n, i.el = e(n), i.suggestions = [], i.badQueries = [], i.selectedIndex = -1, i.currentValue = i.element.value, i.intervalId = 0, i.cachedResponse = {}, i.onChangeInterval = null, i.onChange = null, i.isLocal = !1, i.suggestionsContainer = null, i.noSuggestionsContainer = null, i.options = e.extend({}, a, o), i.classes = {
            selected: "selected",
            suggestion: "suggestion-item"
        }, i.hint = null, i.hintValue = "", i.selection = null, i.initialize(), i.setOptions(o)
    }
    var n = {
        escapeRegExChars: function (e) {
            return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
        },
        createNode: function (e) {
            var t = document.createElement("div");
            return t.className = e, t.style.position = "absolute", t.style.display = "none", t
        }
    },
        o = {
            ESC: 27,
            TAB: 9,
            RETURN: 13,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40
        };
    t.utils = n, e.Autocomplete = t, t.formatResult = function (e, t) {
        var o = "(" + n.escapeRegExChars(t) + ")";
        return e.value.replace(new RegExp(o, "gi"), "<span>$1</span>")
    }, t.prototype = {
        killerFn: null,
        initialize: function () {
            var n,
                o = this,
                s = "." + o.classes.suggestion,
                i = o.classes.selected,
                a = o.options;
            o.element.setAttribute("autocomplete", "off"), o.killerFn = function (t) {
                0 === e(t.target).closest("." + o.options.containerClass).length && (o.killSuggestions(), o.disableKillerFn())
            }, o.noSuggestionsContainer = e('<div class="no-suggestion"></div>').html(this.options.noSuggestionNotice).get(0), o.suggestionsContainer = t.utils.createNode(a.containerClass), (n = e(o.suggestionsContainer)).appendTo(a.appendTo), "auto" !== a.width && n.width(a.width), n.on("mouseover.autocomplete", s, function () {
                o.activate(e(this).data("index"))
            }), n.on("mouseout.autocomplete", function () {
                o.selectedIndex = -1, n.children("." + i).removeClass(i)
            }), n.on("click.autocomplete", s, function () {
                o.select(e(this).data("index"))
            }), o.fixPositionCapture = function () {
                o.visible && o.fixPosition()
            }, e(window).on("resize.autocomplete", o.fixPositionCapture), o.el.on("keydown.autocomplete", function (e) {
                o.onKeyPress(e)
            }), o.el.on("keyup.autocomplete", function (e) {
                o.onKeyUp(e)
            }), o.el.on("blur.autocomplete", function () {
                o.onBlur()
            }), o.el.on("focus.autocomplete", function () {
                o.onFocus()
            }), o.el.on("change.autocomplete", function (e) {
                o.onKeyUp(e)
            })
        },
        onFocus: function () {
            var e = this;
            e.fixPosition(), e.options.minChars <= e.el.val().length && e.onValueChange()
        },
        onBlur: function () {
            this.enableKillerFn()
        },
        setOptions: function (t) {
            var n = this,
                o = n.options;
            e.extend(o, t), n.isLocal = e.isArray(o.lookup), n.isLocal && (o.lookup = n.verifySuggestionsFormat(o.lookup)), o.orientation = n.validateOrientation(o.orientation, "bottom"), e(n.suggestionsContainer).css({
                "max-height": o.maxHeight + "px",
                width: o.width + "px",
                "z-index": o.zIndex
            })
        },
        clearCache: function () {
            this.cachedResponse = {}, this.badQueries = []
        },
        clear: function () {
            this.clearCache(), this.currentValue = "", this.suggestions = []
        },
        disable: function () {
            var e = this;
            e.disabled = !0, e.currentRequest && e.currentRequest.abort()
        },
        enable: function () {
            this.disabled = !1
        },
        fixPosition: function () {
            var t = this,
                n = e(t.suggestionsContainer),
                o = n.parent().get(0);
            if (o === $("#storeSearchForm .input-wrapper") || t.options.forceFixPosition) {
                // if (o === document.body || t.options.forceFixPosition) {
                var s = t.options.orientation,
                    i = n.outerHeight(),
                    a = t.el.outerHeight() + 2,
                    r = t.el.offset(),
                    l = {
                        top: r.top + 1,
                        left: r.left,
                    };
                if ("auto" == s) {
                    var u = e(window).height(),
                        c = e(window).scrollTop(),
                        g = -c + r.top - i,
                        d = c + u - (r.top + a + i);
                    s = Math.max(g, d) === g ? "top" : "bottom"
                }
                if (l.top += "top" === s ? -i : a, o !== $("#storeSearchForm .input-wrapper")) {
                    // if (l.top += "top" === s ? -i : a, o !== document.body) {
                    var h,
                        f = n.css("opacity");
                    t.visible || n.css("opacity", 0).show(), h = n.offsetParent().offset(), l.top -= h.top, l.left -= h.left, t.visible || n.css("opacity", f).hide()
                }
                "auto" === t.options.width && (l.width = t.el.outerWidth() + "px"), n.css(l)
            }
        },
        enableKillerFn: function () {
            var t = this;
            e(document).on("click.autocomplete", t.killerFn)
        },
        disableKillerFn: function () {
            var t = this;
            e(document).off("click.autocomplete", t.killerFn)
        },
        killSuggestions: function () {
            var e = this;
            e.stopKillSuggestions(), e.intervalId = window.setInterval(function () {
                e.hide(), e.stopKillSuggestions()
            }, 50)
        },
        stopKillSuggestions: function () {
            window.clearInterval(this.intervalId)
        },
        isCursorAtEnd: function () {
            var e,
                t = this,
                n = t.el.val().length,
                o = t.element.selectionStart;
            return "number" == typeof o ? o === n : !document.selection || ((e = document.selection.createRange()).moveStart("character", -n), n === e.text.length)
        },
        onKeyPress: function (e) {
            var t = this;
            if (t.disabled || t.visible || e.which !== o.DOWN || !t.currentValue) {
                if (!t.disabled && t.visible) {
                    switch (e.which) {
                        case o.ESC:
                            t.el.val(t.currentValue), t.hide();
                            break;
                        case o.RIGHT:
                            if (t.hint && t.options.onHint && t.isCursorAtEnd()) {
                                t.selectHint();
                                break
                            }
                            return;
                        case o.TAB:
                            if (t.hint && t.options.onHint)
                                return void t.selectHint();
                        case o.RETURN:
                            t.hide();
                            if (-1 === t.selectedIndex)
                                return void t.hide();
                            if (t.select(t.selectedIndex), e.which === o.TAB && !1 === t.options.tabDisabled)
                                return;
                            break;
                        case o.UP:
                            t.moveUp();
                            break;
                        case o.DOWN:
                            t.moveDown();
                            break;
                        default:
                            return
                    }
                    e.stopImmediatePropagation(), e.preventDefault()
                }
            } else
                t.suggest()
        },
        onKeyUp: function (e) {
            var t = this;
            if (!t.disabled) {
                switch (e.which) {
                    case o.UP:
                    case o.DOWN:
                        return
                }
                clearInterval(t.onChangeInterval), t.currentValue !== t.el.val() && (t.findBestHint(), t.options.deferRequestBy > 0 ? t.onChangeInterval = setInterval(function () {
                    t.onValueChange()
                }, t.options.deferRequestBy) : t.onValueChange())
            }
        },
        onValueChange: function () {
            var t,
                n = this,
                o = n.options,
                s = n.el.val(),
                i = n.getQuery(s);
            n.selection && (n.selection = null, (o.onInvalidateSelection || e.noop).call(n.element)), clearInterval(n.onChangeInterval), n.currentValue = s, n.selectedIndex = -1, o.triggerSelectOnValidInput && -1 !== (t = n.findSuggestionIndex(i)) ? n.select(t) : i.length < o.minChars ? n.hide() : n.getSuggestions(i)
        },
        findSuggestionIndex: function (t) {
            var n = this,
                o = -1,
                s = t.toLowerCase();
            return e.each(n.suggestions, function (e, t) {
                if (t.value.toLowerCase() === s)
                    return o = e, !1
            }), o
        },
        getQuery: function (t) {
            var n,
                o = this.options.delimiter;
            return o ? (n = t.split(o), e.trim(n[n.length - 1])) : t
        },
        getSuggestionsLocal: function (t) {
            var n,
                o = this.options,
                s = t.toLowerCase(),
                i = o.lookupFilter,
                a = parseInt(o.lookupLimit, 10);
            return n = {
                suggestions: e.grep(o.lookup, function (e) {
                    return i(e, t, s)
                })
            }, a && n.suggestions.length > a && (n.suggestions = n.suggestions.slice(0, a)), n
        },
        getSuggestions: function (t) {
            var n,
                o,
                s,
                i = this,
                a = i.options,
                r = a.serviceUrl;
            if (a.params[a.paramName] = t, o = a.ignoreParams ? null : a.params, i.isLocal ? n = i.getSuggestionsLocal(t) : (e.isFunction(r) && (r = r.call(i.element, t)), s = r + "?" + e.param(o || {}), n = i.cachedResponse[s]), n && e.isArray(n.suggestions))
                i.suggestions = n.suggestions, i.suggest();
            else if (!i.isBadQuery(t)) {
                if (!1 === a.onSearchStart.call(i.element, a.params))
                    return;
                i.currentRequest && i.currentRequest.abort(), i.currentRequest = e.ajax({
                    url: r,
                    data: o,
                    type: a.type,
                    dataType: a.dataType
                }).done(function (e) {
                    var n;
                    i.currentRequest = null, n = a.transformResult(e), i.processResponse(n, t, s), a.onSearchComplete.call(i.element, t, n.suggestions)
                }).fail(function (e, n, o) {
                    a.onSearchError.call(i.element, t, e, n, o)
                })
            }
        },
        isBadQuery: function (e) {
            if (!this.options.preventBadQueries)
                return !1;
            for (var t = this.badQueries, n = t.length; n--;)
                if (0 === e.indexOf(t[n]))
                    return !0;
            return !1
        },
        hide: function () {
            var t = this;
            t.visible = !1, t.selectedIndex = -1, e(t.suggestionsContainer).hide(), t.signalHint(null)
        },
        suggest: function () {
            if (0 !== this.suggestions.length) {
                var t,
                    n = this,
                    o = n.options,
                    s = o.formatResult,
                    i = n.getQuery(n.currentValue),
                    a = n.classes.suggestion,
                    r = n.classes.selected,
                    l = e(n.suggestionsContainer),
                    u = e(n.noSuggestionsContainer),
                    c = o.beforeRender,
                    g = "";
                o.triggerSelectOnValidInput && -1 !== (t = n.findSuggestionIndex(i)) ? n.select(t) : (e.each(n.suggestions, function (e, t) {
                    g += '<div class="' + a + '" data-index="' + e + '"><span class="marker-icon"></span>' + s(t, i) + "</div>"
                }), this.adjustContainerWidth(), u.detach(), l.html(g), o.autoSelectFirst && (n.selectedIndex = 0, l.children().first().addClass(r)), e.isFunction(c) && c.call(n.element, l), n.fixPosition(), l.show(), n.visible = !0, n.findBestHint())
                // LGECS-349 start
                if( $("input[name='ivrFlag']").length > 0 && $("input[name='ivrFlag']").val() == "Y"){
                	if( l.length > 0){
                		$(l).find("div:eq(0)").click();
                		$("#repairForm").trigger('submit');
                	}
                }
                // LGECS-349 end
            } else
                this.options.showNoSuggestionNotice ? this.noSuggestions() : this.hide()
        },
        noSuggestions: function () {
            var t = this,
                n = e(t.suggestionsContainer),
                o = e(t.noSuggestionsContainer);
            this.adjustContainerWidth(), o.detach(), n.empty(), n.append(o), t.fixPosition(), n.show(), t.visible = !0
        },
        adjustContainerWidth: function () {
            var t,
                n = this,
                o = n.options,
                s = e(n.suggestionsContainer);
            // EDIT HERE TO CHANGE WIDTH OF SUGGESTION BOX!!!!!
            "auto" === o.width && (t = n.el.outerWidth(), s.width(t > 0 ? t : 300))
        },
        findBestHint: function () {
            var t = this,
                n = t.el.val().toLowerCase(),
                o = null;
            n && (e.each(t.suggestions, function (e, t) {
                var s = 0 === t.value.toLowerCase().indexOf(n);
                return s && (o = t), !s
            }), t.signalHint(o))
        },
        signalHint: function (t) {
            var n = "",
                o = this;
            t && (n = o.currentValue + t.value.substr(o.currentValue.length)), o.hintValue !== n && (o.hintValue = n, o.hint = t, (this.options.onHint || e.noop)(n))
        },
        verifySuggestionsFormat: function (t) {
            return t.length && "string" == typeof t[0] ? e.map(t, function (e) {
                return {
                    value: e,
                    data: null
                }
            }) : t
        },
        validateOrientation: function (e, t) {
            return e = e.replace(/^\s+|\s+$/g, "").toLowerCase(), jQuery.inArray(e, ["auto", "bottom", "top"]) && (e = t), e
        },
        processResponse: function (e, t, n) {
            var o = this,
                s = o.options;
            e.suggestions = o.verifySuggestionsFormat(e.suggestions), s.noCache || (o.cachedResponse[n] = e, s.preventBadQueries && 0 === e.suggestions.length && o.badQueries.push(t)), t === o.getQuery(o.currentValue) && (o.suggestions = e.suggestions, o.suggest())
        },
        activate: function (t) {
            var n,
                o = this,
                s = o.classes.selected,
                i = e(o.suggestionsContainer),
                a = i.children();
            return i.children("." + s).removeClass(s), o.selectedIndex = t, -1 !== o.selectedIndex && a.length > o.selectedIndex ? (n = a.get(o.selectedIndex), e(n).addClass(s), n) : null
        },
        selectHint: function () {
            var t = this,
                n = e.inArray(t.hint, t.suggestions);
            t.select(n)
        },
        select: function (e) {
            var t = this;
            t.hide(), t.onSelect(e)
        },
        moveUp: function () {
            var t = this;
            if (-1 !== t.selectedIndex)
                return 0 === t.selectedIndex ? (e(t.suggestionsContainer).children().first().removeClass(t.classes.selected), t.selectedIndex = -1, t.el.val(t.currentValue), void t.findBestHint()) : void t.adjustScroll(t.selectedIndex - 1)
        },
        moveDown: function () {
            var e = this;
            e.selectedIndex !== e.suggestions.length - 1 && e.adjustScroll(e.selectedIndex + 1)
        },
        adjustScroll: function (t) {
            var n,
                o,
                s,
                i = this,
                a = i.activate(t);
            a && (n = a.offsetTop, s = (o = e(i.suggestionsContainer).scrollTop()) + i.options.maxHeight - 25, n < o ? e(i.suggestionsContainer).scrollTop(n) : n > s && e(i.suggestionsContainer).scrollTop(n - i.options.maxHeight + 25), i.el.val(i.getValue(i.suggestions[t].value)), i.signalHint(null))
        },
        onSelect: function (t) {
            var n = this,
                o = n.options.onSelect,
                s = n.suggestions[t];
            n.currentValue = n.getValue(s.value), n.currentValue !== n.el.val() && n.el.val(n.currentValue), n.signalHint(null), n.suggestions = [], n.selection = s, e.isFunction(o) && o.call(n.element, s)
        },
        getValue: function (e) {
            var t,
                n,
                o = this,
                s = o.options.delimiter;
            return s ? (t = o.currentValue, n = t.split(s), 1 === n.length ? e : t.substr(0, t.length - n[n.length - 1].length) + e) : e
        },
        dispose: function () {
            var t = this;
            t.el.off(".autocomplete").removeData("autocomplete"), t.disableKillerFn(), e(window).off("resize.autocomplete", t.fixPositionCapture), e(t.suggestionsContainer).remove()
        }
    }, e.fn.autocomplete = function (n, o) {
        return 0 === arguments.length ? this.first().data("autocomplete") : this.each(function () {
            var s = e(this),
                i = s.data("autocomplete");
            "string" == typeof n ? i && "function" == typeof i[n] && i[n](o) : (i && i.dispose && i.dispose(), i = new t(this, n), s.data("autocomplete", i))
        })
    }
}(jQuery);

var myMap,
    myClusterer,
    preDisabled = 0,
    isClicked = 0,
    firstTime = 1,
    flag = 1,
    model,
    templateList = $('#storeResult').find('template.list'),
    templateInfoBox = $('#storeResult').find('template.map'),
    listCopy = templateList.clone().html(),
    infoBoxCopy = templateInfoBox.clone().html(),
    distanceFlag = 1;


$(function () {
    var self = this;
    self.$cont = $('.find-service-center-wrap');
 
    // offline components
    self.$offlineObj = self.$cont.find('.find-service-center');
    self.$offlineSearch = self.$offlineObj.find('.search-results');
    self.$offlineList = self.$offlineObj.find('.map-container');

    if (self.$cont.length === 0) return false;

    // 2. OFFLINE => map cookie list - ls-popup-last-displayed, ls-popup-2, HUID
    
    // 2.1. OFFLINE SHOP => longitude: x axis position, latitude: y axis position
    if (self.$offlineObj) {
        self.$offlineObj.addClass('active');
        var mapFlag = false;
        var s = document.createElement('script');
        // ru_RU 로 (지도 언어) 변경
        s.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&onload=init&apikey=545d766c-8af2-49aa-9547-e7808938c323';
        
        s.type = 'text/javascript';

        // load API data when content is in screen
        $(window).scroll(function (e) {
            if (self.$offlineObj.length > 0) {
                var t2 = self.$offlineObj.offset().top;
                var b2 = t2 + self.$offlineObj.eq(0).height();
                if (isInScreen(t2, b2)) {
                    if (!mapFlag) {
                        mapFlag = true;
                        document.body.appendChild(s);
                    }
                }
            }
        }).scroll();            
    }
    
});

var init = function () {
    var localStore = $('.find-service-center'),
        g_lng = parseFloat(localStore.data('default-longitude')),
        g_lat = parseFloat(localStore.data('default-latitude'));
    
    templateList.remove();
    templateInfoBox.remove();
    
    if (typeof (ymaps) != "undefined") {
        ymaps.ready(function () {
        	/* Directions */
        	routeTypeSelector = new ymaps.control.ListBox({
                data: {
                    content: 'Как добраться'
                },
                items: [
                    new ymaps.control.ListBoxItem({data: {content: "На машине"},state: {selected: true}}),
                    new ymaps.control.ListBoxItem({data: {content: "Общественным транспортом"}}),
                    new ymaps.control.ListBoxItem({data: {content: "Пешком"}})
                ],
                options: {
                    itemSelectOnClick: false
                }
            });
        	/*// Directions */
        	
        	var controlsArr = ['fullscreenControl'];
        	if(self.openDirection){ /* Directions */
        		controlsArr = ['fullscreenControl', routeTypeSelector];
        	}
        	
        	// A-1. create an initial yandex Map
        	myMap = new ymaps.Map("yandex_map", {
            	center: [g_lat, g_lng],
            	zoom: 11,
                minZoom: 10,
                controls: controlsArr,
                behaviors: ['drag', 'dblClickZoom', 'scrollZoom']
            });
            
            // A-2 adding a zoom control to the map (position right)
            myMap.controls.add('zoomControl', {
                float: 'none',
                position: {
                    right: 12,
                    bottom: 30,
                    size: 'small'
                }
            });
            
            // B. setting icon images and balloon layout for clusters
            if ($(window).width() >= 768) {
                var clusterIconsLg = [{
                    href: '/lg5-common-gp/images/customer/ru-marker-icon-lg.svg',
                    size: [40, 56],
                    offset: [-20, -28]
                }],
                    clusterContentLayout = ymaps.templateLayoutFactory.createClass(
                        '<div style="color: #FFFFFF; font-weight: bold; font-size:18px;">{{ properties.geoObjects.length }}</div>'
                    ),
                    customItemContentLayout = ymaps.templateLayoutFactory.createClass(
                        '<div class="carousel-inner">$[geoObject.properties.balloonContent]</div>'
                    ),
                    clusterBalloonLayout = ymaps.templateLayoutFactory.createClass(
                        '<div class="cluster-window info-window"><a href="#" class="window-close" id="infoWindowClose"><div class="sr-only">Закрыть</div></a>' +
                        '<div class="popover-cluster-inner">$[[options.contentLayout]]</div>' +
                        '<div class="arrow info-window-bottom"></div>' +
                        '</div>', {
                        build: function () {
                            this.constructor.superclass.build.call(this);
                            this._$element = $('.info-window', this.getParentElement());
                            this.applyElementOffset();
                            this._$element.find('.window-close').on('click', $.proxy(this.onCloseClick, this));
                        },
                        clear: function () {
                            this._$element.find('.window-close').off('click');
                            this.constructor.superclass.clear.call(this);
                        },
                        onSublayoutSizeChange: function () {
                            clusterBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);
                            if (!this._isElement(this._$element)) {
                                return;
                            }
                            this.applyElementOffset();
                            this.events.fire('shapechange');
                            flag = 1;
                        },
                        applyElementOffset: function () {
                            this._$element.css({
                                left: -(this._$element[0].offsetWidth / 2) + 20,
                                top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
                            });
                        },
                        onCloseClick: function (e) {
                            e.preventDefault();
                            this.events.fire('userclose');
                        },
                        getShape: function () {
                            preDisabled = 1;
                            if (!this._isElement(this._$element)) {
                                return clusterBalloonLayout.superclass.getShape.call(this);
                            }
                            var position = this._$element.position();
                            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top], [
                                    position.left + this._$element[0].offsetWidth,
                                    position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
                                ]
                            ]));
                        },
                        _isElement: function (element) {
                            preDisabled = 0;
                            return element && element[0] && element.find('.arrow')[0];
                        }
                    });
                myClusterer = new ymaps.Clusterer({
                    clusterIcons: clusterIconsLg,
                    clusterIconContentLayout: clusterContentLayout,
                    clusterDisableClickZoom: false,
                    minClusterSize: 4,
                    hideIconOnClustererOpen: false,
                    clusterHideIconOnBalloonOpen: false,
                    clusterBalloonPanelMaxMapArea: 0,
                    clusterOpenBalloonOnClick: false,
                    clusterBalloonLayout: clusterBalloonLayout,
                    clusterBalloonContentLayout: 'cluster#balloonCarousel',
                    clusterBalloonItemContentLayout: customItemContentLayout,
                    clusterBalloonContentLayoutWidth: 360,
                    clusterBalloonPagerSize: 5,
                    balloonOffset: [1, -25]
                });
                // myMap.balloon.setOptions('balloonAutoPanMargin', 50);
            } else {
                var clusterIconsMd = [{
                    href: '/lg5-common-gp/images/customer/ru-marker-icon-md.svg',
                    size: [40, 56],
                    offset: [-20, -28]
                }],
                    clusterContentLayout = ymaps.templateLayoutFactory.createClass(
                        '<div style="color: #FFFFFF; font-weight: bold; font-size:18px;">{{ properties.geoObjects.length }}</div>'
                    ),
                    customItemContentLayout = ymaps.templateLayoutFactory.createClass(
                        '<div class="carousel-inner">$[geoObject.properties.balloonContent]</div>'
                    ),
                    clusterBalloonLayout = ymaps.templateLayoutFactory.createClass(
                        '<div class="cluster-window info-window"><a href="#" class="window-close" id="infoWindowClose"><div class="sr-only">скрыть</div></a>' +
                        '<div class="popover-cluster-inner">$[[options.contentLayout]]</div>' +
                        '<div class="arrow info-window-bottom"></div>' +
                        '</div>', {
                        build: function () {
                            this.constructor.superclass.build.call(this);
                            this._$element = $('.info-window', this.getParentElement());
                            this.applyElementOffset();
                            this._$element.find('.window-close').on('click', $.proxy(this.onCloseClick, this));
                        },
                        clear: function () {
                            this._$element.find('.window-close').off('click');
                            this.constructor.superclass.clear.call(this);
                        },
                        onSublayoutSizeChange: function () {
                            clusterBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);
                            if (!this._isElement(this._$element)) {
                                return;
                            }
                            this.applyElementOffset();
                            this.events.fire('shapechange');
                            flag = 1;
                        },
                        applyElementOffset: function () {
                            this._$element.css({
                                left: -(this._$element[0].offsetWidth / 2) + 20,
                                top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
                            });
                        },
                        onCloseClick: function (e) {
                            e.preventDefault();
                            this.events.fire('userclose');
                        },
                        getShape: function () {
                            preDisabled = 1;
                            if (!this._isElement(this._$element)) {
                                return clusterBalloonLayout.superclass.getShape.call(this);
                            }
                            var position = this._$element.position();
                            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top], [
                                    position.left + this._$element[0].offsetWidth,
                                    position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
                                ]
                            ]));
                        },
                        _isElement: function (element) {
                            return element && element[0] && element.find('.arrow')[0];
                        }
                    });
                myClusterer = new ymaps.Clusterer({
                    clusterIcons: clusterIconsMd,
                    clusterIconContentLayout: clusterContentLayout,
                    clusterDisableClickZoom: false,
                    minClusterSize: 4,
                    hideIconOnClustererOpen: false,
                    clusterHideIconOnBalloonOpen: false,
                    clusterBalloonPanelMaxMapArea: 0,
                    clusterOpenBalloonOnClick: false,
                    clusterBalloonLayout: clusterBalloonLayout,
                    clusterBalloonContentLayout: 'cluster#balloonCarousel',
                    clusterBalloonItemContentLayout: customItemContentLayout,
                    clusterBalloonContentLayoutWidth: 300,
                    clusterBalloonPagerSize: 5,
                    balloonOffset: [1, -25]
                });
                myMap.balloon.setOptions('balloonAutoPanMargin', 30);
            }
            myMap.geoObjects.add(myClusterer);
            
            /* Directions */
            ymaps.modules.define('MultiRouteCustomView', [
        	    'util.defineClass'
        	], function (provide, defineClass) {
        	    // Class for a simple textual view of the multiroute model.
        	    function CustomView (multiRouteModel) {
        	        this.multiRouteModel = multiRouteModel;
        	        // Declaring the initial state.
        	        this.state = "init";
        	        this.stateChangeEvent = null;
        	        // The element the text will be displayed in.
        	        this.outputElement = $('<ul class="list-wrap"></ul>').appendTo('#viewContainer');

        	        this.rebuildOutput();

        	        /**
        	         * Subscribing to model events in order to
        	         *  update the multiroute's text description.
        	         */
        	        multiRouteModel.events
        	            .add(["requestsuccess", "requestfail", "requestsend"], this.onModelStateChange, this);
        	    }

        	    // Mapping table for the state ID to its handler.
        	    CustomView.stateProcessors = {
        	        init: "processInit",
        	        requestsend: "processRequestSend",
        	        requestsuccess: "processSuccessRequest",
        	        requestfail: "processFailRequest"
        	    };

        	    // Mapping table for the route type to its handler.
        	    CustomView.routeProcessors = {
        	        "driving": "processDrivingRoute",
        	        "masstransit": "processMasstransitRoute",
        	        "pedestrian": "processPedestrianRoute"
        	    };

        	    defineClass(CustomView, {
        	        // Handler for model events.
        	        onModelStateChange: function (e) {
        	            // Storing the model state and reconstructing the text description.
        	            this.state = e.get("type");
        	            this.stateChangeEvent = e;
        	            this.rebuildOutput();
        	        },

        	        rebuildOutput: function () {
        	            // Taking the handler for the current state from the table and executing it.
        	            var processorName = CustomView.stateProcessors[this.state];
        	            this.outputElement.html(
        	                this[processorName](this.multiRouteModel, this.stateChangeEvent)
        	            );
        	        },

        	        processInit: function () {
        	        	$('body').trigger('ajaxLoadBefore');
        	        	$('#directionResult').find('.suggest').show();
    	            	$('#directionResult').find('.no-items').hide();
        	            return "Инициализация...."; 
        	        },

        	        processRequestSend: function () {
        	        	$('#directionResult').find('.suggest').show();
    	            	$('#directionResult').find('.no-items').hide();
        	        	$('body').trigger('ajaxLoadBefore');
        	            return "Запрашиваем данные..."; 
        	        },

        	        processSuccessRequest: function (multiRouteModel, e) {
        	            var routes = multiRouteModel.getRoutes(),
        	                result = []
        	            if (routes.length) {
        	                //result.push("Total routes: " + routes.length + ".");
        	            	$('#directionResult').find('.suggest').show();
        	            	$('#directionResult').find('.no-items').hide();
        	                for (var i = 0, l = routes.length; i < l; i++) {
        	                    result.push(this.processRoute(i, routes[i]));
        	                }
        	            } else {
        	                //result.push("<span style='color:red;'>No rotes found.</span>");
        	            	$('#directionResult').find('.suggest').hide();
        	            	$('#directionResult').find('.no-items').show();
        	            }
        	            if(!!$('#viewContainer').find('.list-box').length){
        	            	$('#directionResult').find('.suggest').show();
        	            	$('#directionResult').find('.no-items').hide();
        	            }
        	            $('body').trigger('ajaxLoadEnd');
        	            return result;
        	        },

        	        processFailRequest: function (multiRouteModel, e) {
        	        	$('body').trigger('ajaxLoadEnd');
        	            return e.get("error").message;
        	        },

        	        processRoute: function (index, route) {
        	            // Taking the handler for this route type from the table and applying it.
        	            var processorName = CustomView.routeProcessors[route.properties.get("type")];
        	            return '<li class="list-box"><div class="icon-marker circle">'+(index + 1) + '</div><div class="list-text-block">' + this[processorName](route)+'</div></li>';
        	        },

        	        processDrivingRoute: function (route) {
        	            var result = ['<div class="repair-center-name">Автомобильный маршрут.</div>']
        	            result.push(this.createCommonRouteOutput(route));
        	            return result.join("");
        	        },

        	        processMasstransitRoute: function (route) {
        	            var result = ['<div class="repair-center-name">Примеры. Маршрут на общественном транспорте.</div>']
        	            result.push(this.createCommonRouteOutput(route));
        	            result.push('<div class="repair-description">Описание маршрута: <ul class="list">' + this.createMasstransitRouteOutput(route) + '</ul></div>');
        	            return result.join("");
        	        },

        	        processPedestrianRoute: function (route) {
        	            var result = ['<div class="repair-center-name">Маршрут пешком.</div>']
        	            result.push(this.createCommonRouteOutput(route));
        	            return result.join("");
        	        },

        	        // A method that creates a common part of the description for all types of routes.
        	        createCommonRouteOutput: function (route) {
        	            return '<div class="repair-address">Длина маршрута: ' + route.properties.get("distance").text + '</div>' + 
        	                '<div class="repair-time">Время в пути: ' + route.properties.get("duration").text+'</div>';
        	        },

        	        /**
        	         * The method builds a list of text descriptions for all segments
        	         * of the route on public transport.
        	         */
        	        createMasstransitRouteOutput: function (route) {
        	            var result = [];
        	            for (var i = 0, l = route.getPaths().length; i < l; i++) {
        	                var path = route.getPaths()[i];
        	                for (var j = 0, k = path.getSegments().length; j < k; j++) {
        	                    result.push("<li>" + path.getSegments()[j].properties.get("text") + "</li>");
        	                }
        	            }
        	            return result.join("");
        	        },

        	        destroy: function () {
        	            this.outputElement.remove();
        	            this.multiRouteModel.events
        	                .remove(["requestsuccess", "requestfail", "requestsend"], this.onModelStateChange, this);
        	        }
        	    });

        	    provide(CustomView);
        	});
            /*// Directions */
            
            // LGECS-349 start
            if( $("input[name='ivrFlag']").length > 0 && $("input[name='ivrFlag']").val() == "Y"){
				if( $("#countryList").length > 0){
					$("#countryList").val($("input[name='ivrCountry']").val()).trigger("chosen:updated");
				}
				
				$("#mapSearch").val($("input[name='ivrZipCode']").val()).trigger("change");
			}
            // LGECS-349 end
        });
        addInputEvents();
    }
};
var addInputEvents = function () {
    var self = this;
    self.$cont = $('.find-service-center-wrap');
    self.$localStore = $('.find-service-center');
    // search input field
    self.$searchResults = self.$localStore.find('.search-results');
    self.$storeSearchForm = self.$searchResults.find('#repairForm');
    self.$mapSearch = self.$storeSearchForm.find('#mapSearch');
    self.$formSubmit = self.$storeSearchForm.find('.submit');
    // search toggle
    self.$toggleBtn = self.$localStore.find('.btn-collapse');
    // latitude and longitude
    self.$g_lng = parseFloat(self.$localStore.data('default-longitude'));
    self.$g_lat = parseFloat(self.$localStore.data('default-latitude'));
    // map area
    self.$mapContainer = self.$localStore.find('.map-container');
    // sidebar result field
    self.$sideBar = self.$mapContainer.find('.repair-map-information');
    self.$mapArea = self.$mapContainer.find('.map-area');
    // search result under the search input box
    self.$storeResult = $('#storeResult');
    self.$storeList = self.$storeResult.find('.list-wrap')
    self.$warning = self.$storeResult.find('.no-items');
    self.$defaultMsg = self.$storeResult.find('.default-msg');
    self.$noItemsMsg = self.$storeResult.find('.no-items');
    
    self.$repairTabmenu = self.$localStore.find('.map-store-distance');
    
    self.distance = self.$repairTabmenu.find('.active').data('distance');
    
    self.$repairForm = $('#repairForm');
    self.$resultLocation = self.$localStore.find('.search-location');
    
    self.$countrySelect = self.$localStore.find('#countryList');
    
    var btnArea = self.$storeResult.find('.btn-area');
    
    /* Directions */
    self.$directionsForm = self.$localStore.find('#directionForm');
    self.openDirection = $('#repairCenter').data('use-direction');
    /*// Directions */
    
    // auto-complete search keywords
    if (self.$mapSearch.length > 0) {
        self.$mapSearch.autocomplete({
            serviceUrl: 'https://suggest-maps.yandex.ru/suggest-geo',
            params: {
                callback: 'show_suggestion',
                lang: 'en-RU',
                ll: self.$g_lng + ',' + self.$g_lat,
                spn: '2.399139,0.624969',
                highlight: 1,
                fullpath: 1,
                sep: 1,
                search_type: 'all'
            },
            paramName: 'part',
            minChars: 1,
            dataType: 'jsonp',
            transformResult: function (data) {
                var result = [];
                for (var i = 0; i < data[1].length; i++) {
                    result.push(data[1][i][2]);
                }
                return {
                    suggestions: result
                };
            },
            showNoSuggestionNotice: true,
            noSuggestionNotice: 'Ничего не найдено...'
        });
    }
    
    /* Direction */
    if(self.openDirection){
    	var myPlacemark = new ymaps.Placemark([self.$g_lat, self.$g_lng], null, {
            iconLayout: 'default#image',
            iconContentOffset: [5, 3],
            iconImageHref: "/lg5-common-gp/images/customer/ru-marker-icon-md.svg",
            iconImageSize: [30, 43],
            iconImageOffset: [-11, -15]
        });

        setTimeout(function () {
        	console.log(myMap);
        	myMap.geoObjects.add(myPlacemark);
        }, 600);
    }
    /*// Direction */
    
    // submit search && trigger => getData();
    $(self.$storeSearchForm).submit(function (e) {
        var geocode = self.$mapSearch.val();
        if (!!e) {
            e.preventDefault();
            if(!$('#repairForm').checkValidation()) return;
            
            self.$storeSearchForm.prop('disabled', true);
            self.$storeSearchForm.contents().find('input').prop('disabled', true);
            self.$mapSearch.find('.suggestion-list').hide();
            
            self.$resultLocation.text(geocode);
            
            $.ajax({
                url: 'https://geocode-maps.yandex.ru/1.x/',
                data: {
                    apikey: '545d766c-8af2-49aa-9547-e7808938c323',
                    geocode: geocode,
                    format: 'json'
                },
                dataType: 'jsonp',
                cache: false,
                success: function (data) {
                    // console.log('success===', data)
                    if (!!data.response) {
                        if (data.response.GeoObjectCollection.featureMember.length > 0) {
                            self.$warning.removeClass('active');
                            var lower = data.response.GeoObjectCollection.featureMember[0].GeoObject.boundedBy.Envelope.lowerCorner.split(' '),
                                upper = data.response.GeoObjectCollection.featureMember[0].GeoObject.boundedBy.Envelope.upperCorner.split(' ');
                            myMap.setBounds([[lower[1], lower[0]], [upper[1], upper[0]]]);
                            getData();
                        } else {
                            // console.log('no geo object found===');
                            myClusterer.removeAll();
                            self.$storeList.empty();
                            self.$warning.addClass('active');
                            btnArea.removeClass('active');
                            return;
                        }
                    } else {
                        // console.log('no response===');
                        myClusterer.removeAll();
                        self.$storeList.empty();
                        self.$warning.addClass('active');
                        btnArea.removeClass('active');
                        return;
                    }
                },
                error: function (data) {
                    myClusterer.removeAll();
                    self.$storeList.empty();
                    self.$warning.addClass('active');
                    btnArea.removeClass('active');
                    return false;
                },
                complete: function (data) {
                    if (firstTime == 1) {
                        attachActions();
                    }
                    self.$storeSearchForm.prop('disabled', false);
                    self.$storeSearchForm.contents().find('input').prop('disabled', false);
                    $sideBar.addClass('active');
                }
            });
        }        
        return false;
    });
    // toggle a side bar => collapse or expand
    self.$toggleBtn.on('click', function (e) {
        e.preventDefault();
        self.$sideBar.toggleClass('active');
        self.$searchResults.toggleClass('active');
        myMap.container.fitToViewport();
    });  
    
    //distance km click event 20201019 LGERU-98 add
    self.$repairTabmenu.find("li a").on('click', function(e){
    	e.preventDefault();
    	if(distanceFlag == 0){
    		var target = $(e.target);
        	self.distance = target.parent().data("distance");
        	
        	$(self.$storeSearchForm).submit();
    	}    	
    	
    });
    
  //country change event 20201019 LGERU-98 add
    self.$countrySelect.off('change').on('change', $.proxy(function(e) {
		var self = this,
			$target = $(e.target),
			dataLat = $target.children('option:selected').data('lat'),
			dataLng = $target.children('option:selected').data('lng'),
			dataZoom = $target.children('option:selected').data('zoom-level');
		
		myMap.setCenter([dataLat, dataLng]);
		myMap.setZoom(dataZoom)

		self.$sideBar.removeClass('active');
		myClusterer.removeAll();
        self.$storeList.empty();
        self.$storeSearchForm.find('[name=searchPostalCode]').val('');
        distanceFlag = 1;
        
        if (self.$mapSearch.length > 0) {
            self.$mapSearch.autocomplete({
                serviceUrl: 'https://suggest-maps.yandex.ru/suggest-geo',
                params: {
                    callback: 'show_suggestion',
                    lang: 'en-RU',
                    ll: dataLng + ',' + dataLat,
                    spn: '2.399139,0.624969',
                    highlight: 1,
                    fullpath: 1,
                    sep: 1,
                    search_type: 'all'
                },
                paramName: 'part',
                minChars: 1,
                dataType: 'jsonp',
                transformResult: function (data) {
                    var result = [];
                    for (var i = 0; i < data[1].length; i++) {
                        result.push(data[1][i][2]);
                    }
                    return {
                        suggestions: result
                    };
                },
                showNoSuggestionNotice: true,
                noSuggestionNotice: 'Ничего не найдено...'
            });
        }
	}, self));
    
    /* Direction */
    self.setDirectionPanel = function(e){
    	e && e.preventDefault();
    	
    	self.directKeyword = document.getElementById("mapSearch").value;
    	self.directResult = document.getElementById('directionResult');
    	if(self.directKeyword == '') return false;
    	
    	$('body').trigger('ajaxLoadBefore');
    	
    	//reset
   	 	myMap.geoObjects.removeAll();
   	 	$('#viewContainer').html('');
   	 	$(self.directResult).find(".repair-error-list").hide();
   	 	$(self.directResult).find(".suggest").show();
		$(self.directResult).find(".route-method").show();
   	 
   	 	var multiRouteModel = new ymaps.multiRouter.MultiRouteModel([
			self.directKeyword,
			[self.$g_lat, self.$g_lng]
			], {
		       /**
		        * Waypoints can be dragged.
		        * The route adjusts when this happens.
		        */
			wayPointDraggable: true,
			boundsAutoApply: true
			}),
			// Getting direct links to the list items.
			autoRouteItem = routeTypeSelector.get(0),
			masstransitRouteItem = routeTypeSelector.get(1),
			pedestrianRouteItem = routeTypeSelector.get(2);
	   	 	
   	 	// Subscribing to click events on drop-down list items.
   	 	autoRouteItem.events.add('click', function (e) { changeRoutingMode('auto', e.get('target')); });
   	 	masstransitRouteItem.events.add('click', function (e) { changeRoutingMode('masstransit', e.get('target')); });
   	 	pedestrianRouteItem.events.add('click', function (e) { changeRoutingMode('pedestrian', e.get('target')); });

   	 	ymaps.modules.require([
   	 		'MultiRouteCustomView'
   	 		], function (MultiRouteCustomView) {
		    /**
		     * Creating an instance of a textual display of the multiroute model.
		     * See the custom_view.js file.
		     */
   	 		new MultiRouteCustomView(multiRouteModel);
   	 		});
    
   	 	var multiRoute = new ymaps.multiRouter.MultiRoute(multiRouteModel, {
		  /**
		 * Waypoints can be dragged.
		 * The route adjusts when this happens.
		 */
   	 		wayPointDraggable: true,
   	 		boundsAutoApply: true
   	 	});
   	 	// Adding a multiroute to the map.
   	 	myMap.geoObjects.add(multiRoute);

   	 	function changeRoutingMode(routingMode, targetItem) {
   	 		multiRouteModel.setParams({ routingMode: routingMode }, true);

   	 		// Disabling an option of selecting elements
   	 		autoRouteItem.deselect();
   	 		masstransitRouteItem.deselect();
   	 		pedestrianRouteItem.deselect();

   	 		// Selecting an element and closing the list.
   	 		targetItem.select();
   	 		routeTypeSelector.collapse();
   	 	}
    
   	 	$('body').trigger('ajaxLoadEnd');
    }
    self.$directionsForm.on('submit', $.proxy(self.setDirectionPanel, self));
    /*// Direction */
};

// user action event listener
var attachActions = function () {
    // map actionend event(Ajax call to refresh data)
    /*myMap.events.add('actionend', function (e) {
        if (firstTime == 0 && !myMap.balloon.isOpen()) {
            if (flag == 0) {
                getData();
            }
            setTimeout(function () {
                flag = 0;
            }, 600);
        }
    });*/
    // balloon open event
    myMap.geoObjects.events.add("balloonopen", function (e) {
        var s = e.originalEvent.currentTarget,
            t = e.get('target').properties._data,
            storeResult = $('#storeResult'),
            el = storeResult.find(".list-wrap"),
            list = storeResult.find(".store-list"),
            item = el.find("[data-id='data-" + t.n + "']"),
            index = item.data('item');
        

        if ($('.navigation').length > 0 && !s.cluster) {
            var currentPage = Math.floor(index / 3),
                dontAnimate = true;
            el.find('.list-box').removeClass('active');
            if (!!el.find("[data-id='data-" + t.n + "']").length) {
            	el.find("[data-id='data-" + t.n + "']").addClass('active');
                if ($(window).width() < 768) {                	
                    if (index >= 0 && index < 3) {
                        el.slick('slickGoTo', 0, dontAnimate)
                    } else {
                        el.slick('slickGoTo', currentPage, dontAnimate);
                    }
                } else {                	
                	list.mCustomScrollbar('scrollTo', el.find("[data-id='data-" + t.n + "']"));
                }
            } else {
                // console.log('id not found====')
            }
        }
    })
};

// AJAX data arguments
var Prep = function () {
    var zoom = myMap.getZoom(),
        radius;

    // if ($(window).width() >= 768) {
    switch (zoom) {
        case (zoom >= 0 && zoom <= 9): radius = 25000; break;
        case 10: radius = 20000; break;
        case 11: radius = 12000; break;
        case 12: radius = 7000; break;
        case 13: radius = 4000; break;
        case 14: radius = 2000; break;
        case 15: radius = 1000; break;
        case 16: radius = 800; break;
        case 17: radius = 500; break;
        case 18: radius = 300; break;
        case 19: radius = 200; break;
    }

    var countryCode = $('.find-service-center').data('country') ? $('.find-service-center').data('country') : "ru",
        center = myMap.getCenter(),
        radius = radius;

    return {
        countryCode: countryCode,
        radius: radius,
        latitude: center[0],
        longitude: center[1],
    };
};

// AJAX req
var getData = function () {
    var BUOffline;
    var prep = Prep.call(this);
    var storeList = $('#storeResult').find('.list-wrap');
    
    self.dataque = $('#repairForm').serialize() + "&" + $.param({
		searchLatitudeValue: prep.latitude,
		searchLongitudeValue: prep.longitude,
		ascDistance: self.distance,
		searchPostalCode : $('#repairForm').find('[name=searchPostalCode]').val()
	});
    self.$repairTabmenu.find("li[data-distance=" + self.distance + "]").addClass("active").siblings("li").removeClass("active");
    
    $.ajax({
        url: self.$localStore.data('query-url'),
        dataType: "jsonp",
        // cache: false,
        data: xssfilter(self.dataque),
        type: 'GET',
        beforeSend: function () {
            $('.find-service-center-wrap .map-container').append('<div class="loading-circle"><div class="lds-dual-ring"></div></div>');
        },
        error: function (error) {
            // console.log('error===', error)
        },
		complete: function() {
			$("input[name='ivrFlag']").val("N"); //LGECS-349
		}
    }).done(function (data) {
        if (firstTime == 0) {
            // Destroy slick after an initial ajaxCall(getData)
            if (storeList.hasClass('slick-slider') || storeList.hasClass('slick-initialized')) {
                storeList.slick('unslick');
            }
            storeList.children().remove();
        }
        handleData(data, slickCarousel);
        $('.find-service-center-wrap .map-container').find('.loading-circle').remove();
        showBalloon();
        firstTime = 0;
        distanceFlag = 0;
    }).fail(function (data) {
        if (data.status == 404) {
            // console.log('404===', data.status);
        }
    });
};
// AJAX data handling
var handleData = function (json, callback) {
    var shopsArr = json,
        storeResult = $('#storeResult'),
        storeList = storeResult.find('.list-wrap'),
        warning = storeResult.find('.no-items'),
        btnArea = storeResult.find('.btn-area'),
        obj = Prep.call(this),
        r = obj.radius,
        newArr = [];
    if (firstTime == 0) {
        newArr = [];
        newArr.length === 0;
        myClusterer.removeAll();
    }

    if (shopsArr !== null || shopsArr != 'undefined') {
        if (!!shopsArr.data.length) {
            $(warning).removeClass('active');
            function distance(lat1, lng1, lat2, lng2) {
                var lat1 = Math.PI / 180 * lat1,
                    lng1 = Math.PI / 180 * lng1,
                    lat2 = Math.PI / 180 * lat2,
                    lng2 = Math.PI / 180 * lng2;
                return Math.round(6378137 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng1 - lng2) + Math.sin(lat1) * Math.sin(lat2)));
            }

            for (var j = 0; j < shopsArr.data.length; j++) {
                addMarkers(shopsArr.data[j], j, newArr);
            }
        } else {
            // if null data received!!!
            $(warning).addClass("active");
            storeList.empty();
            btnArea.removeClass('active');
            myClusterer.removeAll();
            // console.log('data code error--', json.code);
            return;
        }
    } else {
        $(warning).addClass("active");
        storeList.empty();
        btnArea.removeClass('active');
        myClusterer.removeAll();
        // console.log('no json data--', json);
        return;
    }
    // setTimeout(function(){
    callback(newArr);
    // }, 300);
};
var addMarkers = function (pin, idx, arr) {
    var pinData = {},
        balloonData = {},
        localStore = $('.find-service-center'),
        g_lng = parseFloat(localStore.data('default-longitude')),
        g_lat = parseFloat(localStore.data('default-latitude')),
        my_geoloc = [g_lat, g_lng],
        geo_shop = [pin.ascLatitudeValue, pin.ascLongitudeValue];
    // var distance = "";
    if(idx == 0){
    	myMap.setCenter([pin.ascLatitudeValue, pin.ascLongitudeValue]);
    }
    
    // logo
    if (pin.retailerLogo == null || pin.retailerLogo == "undefined") {
        var retailerLogo = "";
    } else {
        var retailerLogo = pin.retailerLogo;
    }
    // address
    if (pin.address == null || pin.address == "undefined") {
        var address = "";
    } else {
        var address = pin.address;
    }
    // distance
    try {
        var distance = ymaps.formatter.distance(
            ymaps.coordSystem.geo.getDistance(my_geoloc, geo_shop)
        );
    } catch (error) {
        // console.log('e===', error);
    }
    // phone number
    if (pin.telephone === 'undefined' || pin.telephone === null) {
        var phone = ""
    } else {
        var phone = pin.ascPhoneNo;
    }
    
    //pinData.id = pin.placeId;
    pinData.distance = distance;
    pinData.retailerId = pin.retailerId;
    pinData.retailerLogo = retailerLogo;
    pinData.retailerName = pin.ascName;
    pinData.address = address;
    pinData.telephone = phone;
    
    pinData.retailerWebsite = pin.retailerWebsite;
    pinData.ascPhoneTxt  = pin.ascPhoneTxt;
    
    pinData.info = pin;
    arr.push(pinData);
    
    setStoreList(arr, idx, listCopy);

    var MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="info-window">' +
        '<a href="#" class="window-close" id="infoWindowClose"><div class="sr-only">Закрыть</div></a>' +
        "$[properties.balloonContent]" +
        '<div class="arrow info-window-bottom"></div>' +
        "</div>", {
        build: function () {
            this.constructor.superclass.build.call(this);
            this._$element = $('.info-window', this.getParentElement());
            this.applyElementOffset();
            this._$element.find('.window-close').on('click', $.proxy(this.onCloseClick, this));
        },
        clear: function () {
            this._$element.find('.window-close').off('click');
            this.constructor.superclass.clear.call(this);
        },
        onSublayoutSizeChange: function () {
            MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);
            if (!this._isElement(this._$element)) {
                return;
            }
            this.applyElementOffset();
            this.events.fire('shapechange');
            flag = 1;
        },
        applyElementOffset: function () {
            this._$element.css({
                left: 20,
                top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
            });
        },
        onCloseClick: function (e) {
            e.preventDefault();
            this.events.fire('userclose');
        },
        getShape: function () {
            preDisabled = 1;
            if (!this._isElement(this._$element)) {
                return MyBalloonLayout.superclass.getShape.call(this);
            }
            var position = this._$element.position();
            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                [position.left, position.top], [
                    position.left + this._$element[0].offsetWidth,
                    position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
                ]
            ]));
        },
        _isElement: function (element) {
            return element && element[0] && element.find('.arrow')[0];
        }
    });
    
    // Set Balloon Content
    // balloonData.id = '5b154be846e0fb00077d8321';//pin.placeId;
    balloonData.n = idx;
    balloonData.balloonContent = setStoreInfo(arr, idx, infoBoxCopy);

    var myPlacemark = new ymaps.Placemark([pin.ascLatitudeValue, pin.ascLongitudeValue], balloonData, {
        iconLayout: 'default#image',
        iconContentOffset: [5, 3],
        //iconImageHref: '/lg5-common-gp/images/customer/ru-marker-icon-small-wh-border.svg',
        iconImageHref: "/lg5-common-gp/images/customer/mark-" + (parseInt(idx, 10) + 101).toString().substr(1) + ".png",
        iconImageSize: [30, 43],
        iconImageOffset: [-11, -15],
        
        balloonLayout: MyBalloonLayout,
        balloonPanelMaxMapArea: 0,
        balloonAutoPan: true,
        hideIconOnBalloonOpen: false,
        balloonOffset: [2, -15]
    });

    myMap.geoObjects.add(myPlacemark);
    myClusterer.add(myPlacemark);
};

// Slick handler
var slickCarousel = function (dataArr) {
    var storeResult = $('#storeResult'),
        storeList = storeResult.find('.list-wrap'),
        btnArea = storeResult.find('.btn-area'),
        totalPage = btnArea.find('.total-page'),
        currentPage = btnArea.find('.current-page');
    
    
    if ($(window).width() < 768) {
        // 1-1.remove mCustomScrollbar on mobile device
        if (storeList.hasClass('mCustomScrollbar')) {
            $(this).mCustomScrollbar('disable', true);
            $(this).mCustomScrollbar("destroy");
        };
        if (dataArr.length > 3) {
            // 2-1. Init => show pagination area with index
            storeList.on('init', function (event, slick) {
                btnArea.addClass("active");
                currentPage.text(1);
                totalPage.text(slick.slideCount);
            });
            // 2-2. Do slick => if slick is not initialized Do slick
            storeList.not('.slick-initialized').slick({
                adaptiveHeight: true,
                rows: 3,
                slidesPerRow: 1,
                infinite: false,
                dots: false,
                speed: 500,
                prevArrow: '.pagination .prev',
                nextArrow: '.pagination .next',
            });
            // 2-3. Update pagination => on afterchange event
            storeList.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                btnArea.addClass("active");
                currentPage.text(i);
                totalPage.text(slick.slideCount);
            });
        } else {
            // 3.remove slick and pagination (on single slide)
            storeResult.find('.store-list').children('.list').slick('unslick');
            btnArea.removeClass('active');
        }
    } else {
        // 1-2. Use mCustromScroll bar & destroy slick
        if (storeList.hasClass('slick-slider') || storeList.hasClass('slick-initialized')) {
            storeList.slick('unslick');
            storeList.mCustomScrollbar('update');            
            btnArea.removeClass('active');
        }        
    }
};

var setStoreList = function (data, itemNum, copy) {
    var data = data[itemNum],
        content = copy
            .replace(/\*itemNum\*/g, itemNum)
            .replace(/\*id\*/g, 'data-'+itemNum)
            .replace(/\*distance\*/g, data["distance"])
            .replace(/\*retailerName\*/g, data["retailerName"])
            .replace(/\*address\*/g, data["address"])
            .replace(/\*itemNumPlus\*/g, itemNum +1)
            //.replace(/\*telephone\*/g, data["telephone"])
      if (data['telephone'] != '' && data['telephone'] != null) content = content.replace(/\*telephone\*/g, "<div class='repair-phonenumber'>" + data['ascPhoneTxt'] + " : <span>"+data['telephone']+"</span></div>")
      else content = content.replace(/\*telephone\*/g, '')
      
      
            
    var $template = $(content),
        $keyBlocks = $template.find('*[data-key]');

    for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
        var $currentKeyBlock = $keyBlocks.eq(i1),
            key = $currentKeyBlock.get(0).getAttribute('data-key'),
            val = data[key];
        if (!val || val == null) {
            $currentKeyBlock.remove();
        }
        if (val == "") {
            $currentKeyBlock.hide();
        }
    }
    var template = $template.get(0).outerHTML;
    var storeList = $('#storeResult').find('.list-wrap');
    storeList.append(template);
};

var setStoreInfo = function (data, itemNum, copy, balloon) {
    var data = data[itemNum];
    var content = copy
        .replace(/\*itemNum\*/g, itemNum)
        .replace(/\*id\*/g, 'data-'+itemNum)
        .replace(/\*retailerLogo\*/g, data["retailerLogo"])
        .replace(/\*distance\*/g, data["distance"])
        .replace(/\*retailerName\*/g, data["retailerName"])
        //.replace(/\*address\*/g, data["address"])
        //.replace(/\*telephone\*/g, data["telephone"])
        
        content = content.replace(/\*ascUrl\*/g, data.info["ascUrl"])
        .replace(/\*ascLatitudeValue\*/g, data.info["ascLatitudeValue"])
        .replace(/\*ascLongitudeValue\*/g, data.info["ascLongitudeValue"])
        .replace(/\*ascPostalCode\*/g, data.info["ascPostalCode"])
        .replace(/\*dmsFlag\*/g, data.info["dmsFlag"])
        
        if (data['address'] != '' && data['address'] != null) content = content.replace(/\*address\*/g, "<div class='repair-address'>" + data['address'] + "</div>")
        else content = content.replace(/\*address\*/g, '')
        
        if (data['telephone'] != '' && data['telephone'] != null) content = content.replace(/\*telephone\*/g, "<div class='repair-phonenumber'>" + data['ascPhoneTxt'] + " : <span>"+data['telephone']+"</span></div>")
        else content = content.replace(/\*telephone\*/g, '')

    var $template = $(content),
        $keyBlocks = $template.find('*[data-key]');

    for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
        var $currentKeyBlock = $keyBlocks.eq(i1),
            key = $currentKeyBlock.get(0).getAttribute('data-key'),
            val = data[key];
        if (!val || val == null) {
            $currentKeyBlock.remove();
        }
    }
    var template = $template.get(0).outerHTML;
    return template;
};

// Balloon click event listener
var showBalloon = function () {
    var listItem = $('#storeResult').find('.list-box'),
        listLink = $('#storeResult').find('a.view-detail-map'),
        len = listLink.length;

    while (len--) {
        listLink[len].addEventListener('click', function (e) {
            e.preventDefault();
            var self = this,
                id = $(self).closest('.list-box').data('id'),
                idxNum = $(self).closest('.list-box').data('item'),
                smClusters = myClusterer.getClusters(),
                obj = myClusterer.getGeoObjects(),
                geoObjectState = myClusterer.getObjectState(obj[idxNum]),
                newCoord = obj[idxNum].geometry.getCoordinates();
            if (isClicked === 1) return;
            myMap.balloon.close();
            

            if (!obj[idxNum].getMap()) {
                if (geoObjectState.isClustered == true) {
                    // console.log('isClustered---')
                    // case A. Clustered geoObjects(placemarks)
                    if (!myMap.balloon.isOpen()) {
                        // # Carousel balloon(for clusters) <= not in use atm
                        // myClusterer.balloon.open(geoObjectState.cluster);

                        // # Normal balloon
                        label1: for (var i = 0; i < smClusters.length; i++) {
                            var j = smClusters[i].properties._data.geoObjects;
                            label2: for (var k = 0; k < j.length; k++) {
                                // console.log('smClusters[i] ===', j.length);
                                if (j[k].geometry._coordinates != newCoord) {
                                    // console.log('NO target===')
                                    continue label2;
                                } else if (j[k].geometry._coordinates == newCoord) {
                                    // console.log('target found===', j[k].geometry._coordinates);
                                    smClusters[i].events.fire("click");
                                    i = k = Number.MAX_VALUE;
                                    // break label1;
                                }
                            }
                        }
                        setTimeout(function () {
                            if (!obj[idxNum].getMap()) {
                                // console.log('isclicked===');
                                //$(self).addClass('active').siblings().removeClass('active');
                                isclicked = 0;
                                // myClusterer.balloon.open(geoObjectState.cluster);
                            } else {
                                obj[idxNum].balloon.open();
                                //$(self).addClass('active').siblings().removeClass('active');
                                // console.log('post after isClicked==');
                            }
                        }, 900);
                    }
                } else {
                    // console.log('bounds setting===');
                    myMap.setBounds(obj[idxNum].geometry._bounds, { checkZoomRange: true });
                    
                    //$(self).addClass('active').siblings().removeClass('active');
                }
            } else {
                // case B. single geoObject(placemark)
                if (!myMap.balloon.isOpen()) {
                    // console.log('single clicked ===');
                    preDisabled = 1;
                    obj[idxNum].balloon.open();
                   // $(self).addClass('active').siblings().removeClass('active');
                } else {
                    // console.log('single placemark balloon opened---');
                    // isClicked = 0;
                    //myMap.balloon.close();
                    //listItem.removeClass("active");
                }
            }
        }, false);
    }
    try{
    	if( !!listLink.length ) myClusterer.getGeoObjects()[0].balloon.open();
    }catch (e) {
		// TODO: handle exception
	}
        
};
